import React from "react"
import { Typography } from "@mui/material"
import { styled } from "@mui/material/styles"

const StyledTypography = styled(Typography)(({ theme }) => ({
  fontFamily: "HiraKakuProN-W3",
  fontSize: "14px",
  lineHeight: 1.75,
  letterSpacing: "normal",
  color: "#333333",
  textAlign: "left",
  [theme.breakpoints.up("md")]: {
    width: "840px",
  },
}))

const ContentsSubText = (props) => {
  return <StyledTypography>{props.children}</StyledTypography>
}

export default ContentsSubText
